import { cn } from '../../lib/utils';

interface FormSelectProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: readonly string[];
  required?: boolean;
  className?: string;
  error?: string;
}

export function FormSelect({
  label,
  name,
  value,
  onChange,
  options,
  required = true,
  className,
  error
}: FormSelectProps) {
  return (
    <div className={cn('relative', className)}>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      
      <select
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className={cn(
          'block w-full px-4 py-3 rounded-xl border transition-all duration-200',
          'bg-white/50 backdrop-blur-sm',
          error 
            ? 'border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-500/20'
            : 'border-gray-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20',
          'text-gray-900'
        )}
      >
        <option value="">Sélectionnez...</option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}